module.exports = __webpack_public_path__ + "media/images/arrow-left-button-dark-e9abdeacbe12d10a9d7fbdf4ac344955.svg";